module.exports = __webpack_public_path__ + "static/media/ARPA-BNB.7bda2b19.svg";